import React from 'react';
import Button from './atoms/Button/Button';
import AECard from './atoms/AECard/AECard';
import astronLogo from '../assets/astron_logo.png';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this.handlePopState = this.handlePopState.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  componentDidMount() {
    window.addEventListener('popstate', this.handlePopState);
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handlePopState);
  }

  handlePopState() {
    if (this.state.hasError) {
      this.setState({ hasError: false, error: null });
    }
  }

  handleGoHome = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-custom-bg p-4">
          <AECard className="max-w-[480px] px-12 pt-20 pb-10 text-center hover:!border-borderColorDefault hover:!shadow-md">
            <img
              src={astronLogo}
              alt="Astron Eye"
              className="mx-auto mb-6 block h-15 w-auto"
            />

            <h1 className="mb-3 text-2xl font-bold text-brandPrimary">
              Something went wrong
            </h1>

            <p className="mb-10 text-md leading-relaxed text-brandSecondary mt-6 font-light">
              An unexpected error occurred.{' '}
              <span className="font-bold">Please return to the home page </span>{' '}
              and try again.{' '}
              <span className="font-bold">
                If the issue persists, contact our support team.
              </span>
            </p>

            <Button
              onClick={this.handleGoHome}
              variant="outline"
              size="lg"
              className="px-6"
            >
              Return to Astron Eye Home
            </Button>

            {/* {import.meta.env.DEV && this.state.error && (
              <details className="mt-8 rounded-lg border border-red-200 bg-red-50 p-4 text-left text-xs text-red-800">
                <summary className="cursor-pointer font-medium text-[13px]">
                  Error details (dev only)
                </summary>
                <pre className="mt-2 whitespace-pre-wrap break-words font-mono">
                  {this.state.error.toString()}
                  {this.state.error.stack && `\n\n${this.state.error.stack}`}
                </pre>
              </details>
            )} */}
          </AECard>
        </div>
      );
    }

    // eslint-disable-next-line react/prop-types
    return this.props.children;
  }
}

export default ErrorBoundary;
